module.exports = __webpack_public_path__ + "img/mappa_tecnico.75223363.png";